import Modal, { ModalActionData } from '@superfunnel/ui-core/Modal';
import Input from '@superfunnel/ui-core/v2/Input';
import { useEffect, useMemo, useState } from 'react';

interface Props {
  mention?: any;
  open: boolean;
  onClose: () => void;
  onSave: (mention: any) => void;
}

export default function EditQuillSearchParamMentionModal({
  mention,
  open,
  onClose,
  onSave,
}: Props) {
  const [searchParam, setSearchParam] = useState(mention?.searchParam ?? '');
  const [defaultValue, setDefaultValue] = useState(mention?.defaultValue ?? '');

  useEffect(() => {
    setSearchParam(mention?.searchParam ?? '');
    setDefaultValue(mention?.defaultValue ?? '');
  }, [open, mention]);

  const actions: ModalActionData[] = useMemo(
    () => [
      {
        title: 'Cancel',
        type: 'secondary',
        onClick: () => onClose(),
      },
      {
        title: 'Save',
        type: 'primary',
        onClick: () =>
          onSave({
            ...mention,
            searchParam,
            defaultValue,
            value: `${searchParam}`,
          }),
      },
    ],
    [defaultValue, mention, onClose, onSave, searchParam],
  );

  return (
    <Modal
      open={open}
      onClose={onClose}
      actions={actions}
      title="Edit Search Param"
    >
      <div className="flex min-h-48 flex-col gap-4">
        <Input
          title="Variable Name"
          value={searchParam}
          onChange={(e) => setSearchParam(e.target.value)}
        />

        <Input
          title="Default Value"
          value={defaultValue}
          onChange={(e) => setDefaultValue(e.target.value)}
        />
      </div>
    </Modal>
  );
}
